import { Link } from 'react-router-dom'

export default function LandingFooter() {
  return (
    <footer className="mt-auto border-t border-cyan-500/10 px-6 py-12">
      <div className="max-w-4xl mx-auto">
        {/* Three columns on md+, stacked on mobile */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <span
              className="select-none tracking-widest uppercase"
              style={{
                fontFamily: "'Barlow', sans-serif",
                fontWeight: 900,
                fontSize: '1rem',
                background: 'linear-gradient(135deg, #06b6d4, #3b82f6)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              GCODR
            </span>
            <p className="font-mono text-xs text-slate-500 mt-2">
              Engineering drawings to G-code. Instantly.
            </p>
          </div>

          {/* Product */}
          <div>
            <h3 className="font-mono text-[10px] tracking-widest uppercase text-slate-500 mb-3">Product</h3>
            <div className="space-y-2">
              <Link to="/features" className="block font-mono text-xs text-slate-500 hover:text-slate-300 transition-colors">Features</Link>
              <Link to="/pricing" className="block font-mono text-xs text-slate-500 hover:text-slate-300 transition-colors">Pricing</Link>
              <Link to="/docs" className="block font-mono text-xs text-slate-500 hover:text-slate-300 transition-colors">Docs</Link>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-mono text-[10px] tracking-widest uppercase text-slate-500 mb-3">Legal</h3>
            <div className="space-y-2">
              <Link to="/terms" className="block font-mono text-xs text-slate-500 hover:text-slate-300 transition-colors">Terms of Service</Link>
              <Link to="/privacy" className="block font-mono text-xs text-slate-500 hover:text-slate-300 transition-colors">Privacy Policy</Link>
              <a href="mailto:contact@gcodr.dev" className="block font-mono text-xs text-slate-500 hover:text-slate-300 transition-colors">contact@gcodr.dev</a>
            </div>
          </div>
        </div>

        {/* Bottom row */}
        <div className="border-t border-cyan-500/10 pt-6">
          <p className="font-mono text-xs text-slate-600">
            &copy; {new Date().getFullYear()} GCodr. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}
